import React from 'react';
import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Text,
	TokenTextAppearance,
	TextTag,
	ThemeProvider,
} from '@volkswagen-onehub/components-core';
import { CloseCircle, ConfiguratorPrivate } from '@volkswagen-onehub/icons-core';
import './VehicleVerificationFeedback.scss';
import { Modal } from '../../models/Modal';

export default function VehicleVerificationFeedback({ state, close }: Modal<VehicleVerificationFeedbackProps>) {
	const { connected, vehicleDataIncomplete, identifyVehicle, t } = state;

	const connectedUX = () => (
		<Container wrap="always" gutter={ContainerGutter.dynamic0100} padding={{ left: ContainerPadding.grid002, right: ContainerPadding.grid002 }}>
			<Text appearance={TokenTextAppearance.headline400}>{t('verificationFeedback.success.title')}</Text>

			<Container wrap="never" gutter={ContainerGutter.dynamic0050} shrinkContent>
				<div style={{ color: '#029640' }}>
					<ConfiguratorPrivate variant="large" />
				</div>
				<Text tag={TextTag.p}>{t('verificationFeedback.success.description')}</Text>
			</Container>

			<CTA
				stretchContent={{ [Breakpoints.default]: true, [Breakpoints.b560]: false }}
				tag="button"
				emphasis="secondary"
				onClick={() => {
					close();
				}}
			>
				{t('general.close')}
			</CTA>
		</Container>
	);

	const notConnectedUX = () => (
		<Container
			shrinkContent
			wrap="always"
			gutter={ContainerGutter.dynamic0100}
			padding={{ left: ContainerPadding.grid002, right: ContainerPadding.grid002 }}
		>
			<Text appearance={TokenTextAppearance.headline400}>{t('verificationFeedback.failure.title')}</Text>

			<Container wrap="never" gutter={ContainerGutter.dynamic0050} shrinkContent>
				<div style={{ color: '#FFD100' }}>
					<CloseCircle variant="large" aria-hidden={true} />
				</div>

				<Text tag={TextTag.p}>{t('verificationFeedback.failure.description')}</Text>
			</Container>

			<Container
				gutter={ContainerGutter.dynamic0050}
				stretchContent={{ [Breakpoints.default]: true, [Breakpoints.b560]: false }}
				wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b560]: 'never' }}
			>
				<CTA
					stretchContent
					tag="button"
					emphasis="secondary"
					onClick={() => {
						close();
					}}
				>
					{t('general.cancel')}
				</CTA>

				<CTA
					stretchContent
					disabled={vehicleDataIncomplete}
					tag="button"
					emphasis="primary"
					onClick={() => {
						close();
						identifyVehicle();
					}}
				>
					{t('verificationFeedback.failure.identifyVehicle')}
				</CTA>
			</Container>
		</Container>
	);

	return <ThemeProvider theme="main">{connected ? connectedUX() : notConnectedUX()}</ThemeProvider>;
}

export interface VehicleVerificationFeedbackProps {
	connected: boolean;
	vehicleDataIncomplete: boolean;
	identifyVehicle: () => void;
	t: any;
}
